import { DEVICE_ROLES } from '@/features/core/container';
import { SpotRole } from '@/types/iot-portal';
import { option } from '@/util/container';
import { component } from '../component';
import lg from './electricity-meter-analog-lg.svg';
import md from './electricity-meter-analog-md.svg';
import sm from './electricity-meter-analog-sm.svg';

export default option(DEVICE_ROLES, async () => ({
  name: SpotRole.ELECTRICITY_METER_ANALOG,
  label: 'Stromzähler (analog)',
  shortLabel: 'Strom',
  icons: { sm, md, lg },
  component: component('electricity-meter-analog/ElectricityMeterAnalogDevicePanel.vue'),
  aggregationWidget: {
    enabled: true,
    component: component('electricity-meter-analog/ElectricityMeterAnalogAggregationWidget.vue'),
  },
  defaultMetricNames: ['currentEnergy'],
  importantMetricNames: ['currentEnergy'],
  consumption: true,
}));
